import type { OfferingModel } from '@sosocio/creator-types/database';
import { PAGE_OFFERING_GROUP_IDS } from 'settings/offering-groups';

type PageOfferingGroup = keyof typeof PAGE_OFFERING_GROUP_IDS;

export function isPageOfferingGroup(
	groupid: number | null | undefined,
	group: PageOfferingGroup,
): boolean {
	return groupid != null && PAGE_OFFERING_GROUP_IDS[group].includes(groupid);
}

export function isBookTypeOffering(
	offeringModel: OfferingModel | null | undefined,
): offeringModel is OfferingModel {
	return Boolean(
		offeringModel
		&& isPageOfferingGroup(
			offeringModel.groupid,
			'BookTypes',
		),
	);
}
